import handleCartModal from './events/handleCartModal.js';
import handleCloseModal from './events/handleCloseModal.js';
import handleAddToCart from './events/handleAddToCart.js';
import handleShowMobileMenu from './events/handleShowMobileMenu.js';
import handleShowMobileAnalog from './events/handleShowMobileAnalog.js';
import handleDeprecatedOpenModal from './events/handleDeprecatedOpenModal.js';
import handleFastDeliveryModal from './events/handleFastDeliveryModal.js';
import handlePickupDeliveryModal from './events/handlePickupDeliveryModal.js';

export default {
    handleCartModal,
    handleCloseModal,
    handleAddToCart,
    handleShowMobileMenu,
    handleShowMobileAnalog,
    handleDeprecatedOpenModal,
    handleFastDeliveryModal,
    handlePickupDeliveryModal,
};
